import JobCommentApi from "../generated/api/JobCommentApi";

class JobCommentService {
  constructor() {
    this.JobCommentApi = new JobCommentApi();
  }

  async addComment(commentRequest, preventAlert) {
    if (preventAlert === undefined) {
      preventAlert = false;
    }
    return await window.$A.HandleApiResponse(
      this.JobCommentApi.addJobComment({ commentRequest }),
      "Comment Added",
      preventAlert
    );
  }

  async updateComment(updateCommentRequest, preventAlert) {
    if (preventAlert === undefined) {
      preventAlert = false;
    }
    const { commentId, comment } = updateCommentRequest || {};
    return await window.$A.HandleApiResponse(
      this.JobCommentApi.editJobComment(commentId, { commentRequest: { comment } }),
      "Comment Updated",
      preventAlert
    );
  }

  async deleteComment(commentId, preventAlert) {
    if (preventAlert === undefined) {
      preventAlert = false;
    }
    return await window.$A.HandleApiResponse(
      this.JobCommentApi.deleteJobComment(commentId),
      "Comment Deleted",
      preventAlert
    );
  }
}

export default JobCommentService;
